import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-brand-line bg-brand-cream px-4 py-5" data-id="element-143" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-4xl" data-id="element-144" data-mp="3fym86mxaf65e">
        <div className="mb-2 text-center" data-id="element-145" data-mp="3fxb38js3vscp">
          <h2 className="mb-0.5 font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-146" data-mp="3b1cjxalmx0j5">
            Ce que disent nos clients
          </h2>
          <p className="font-display text-[11px] font-semibold uppercase tracking-wide text-brand-orange sm:text-sm" data-id="element-147" data-mp="36wmqdseg7y1e">
            ⭐⭐⭐⭐⭐ 4,9/5 — Avis Clients Vérifiés
          </p>
        </div>
        <div className="space-y-2" data-id="element-148" data-mp="2x2mnlx6n34vu">
          {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm" data-id="element-149" data-mp="2s3jfu4z9ykk6">
              <div className="mb-1 flex gap-0.5" aria-label="Note de 5 sur 5" data-id="element-150" data-mp="qa3mv1fpstm1">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-151" data-mp="h4n3qbjitzax" />)}
              </div>
              <p className="mb-2 text-xs font-medium italic leading-snug text-brand-muted sm:text-sm" data-id="element-152" data-mp="c6vdrn2fsn9d">
                « {testimonial.text} »
              </p>
              <div className="flex items-center gap-2.5 border-t border-brand-line pt-2" data-id="element-153" data-mp="zwy3hwivph4t">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-orange/15 font-display text-sm font-extrabold text-brand-orange" data-id="element-154" data-mp="14u7pt3az1cof">
                  {testimonial.author.charAt(0)}
                </span>
                <div className="leading-tight" data-id="element-155" data-mp="v3d4c15juh41">
                  <p className="font-display text-[13px] font-bold text-brand-ink" data-id="element-156" data-mp="1iu8y33tkfmdx">
                    {testimonial.author}
                  </p>
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-brand-muted sm:text-[11px]" data-id="element-157" data-mp="1nnv6gjsp543x">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}